import React from 'react';

import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { Checkbox, FormControlLabel, TextField, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { BiMailSend } from 'react-icons/bi';

import { call } from 'utils';
import { hasResult } from './helpers';

import styles from './StopDialogContent.module.scss';

const StopDialogContent = props => {
  const { questions, showOptions, onChange, required } = props;
  const theme = useTheme();

  const renderOption = (option, question) => {
    const { multiSelect, options, needScores } = question;

    return (
      <div className={styles.option} key={option.key}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={!!option.checked}
              onChange={() => {
                if (!multiSelect) {
                  options.forEach(it => (it !== option ? (it.checked = false) : null));
                }

                option.checked = !option.checked;
                call(onChange, question);
              }}
            />
          }
          label={<Typography variant="body2">{option.text}</Typography>}
        />
        {needScores ? (
          <TextField
            variant="outlined"
            type="number"
            size="small"
            value={option.score || ''}
            onChange={event => {
              option.score = event.target.value;
              call(onChange, question);
            }}
            inputProps={{ min: 0, max: 9999, maxLength: 4 }}
            disabled={!hasResult(question)}
          />
        ) : null}
      </div>
    );
  };

  const renderQuestion = question => {
    const { key, title, options, stopped, needScores, checked } = question || {};

    if (!key) {
      return null;
    }

    const selected = !!(checked || stopped);

    const summary = (
      <FormControlLabel
        style={{ pointerEvents: 'none' }}
        disabled={stopped}
        control={
          <Checkbox
            style={stopped || required ? {} : { pointerEvents: 'visible' }}
            color="primary"
            checked={selected}
            disableRipple={required}
            onChange={
              stopped || required
                ? undefined
                : () => {
                    question.checked = !checked;

                    if (!question.checked) {
                      question.options.forEach(it => {
                        it.checked = false;

                        if (question.needScores) {
                          it.score = '';
                        }
                      });
                    }

                    call(onChange, question);
                  }
            }
          />
        }
        label={
          <Typography variant="body2" style={{ padding: '5px 0' }}>
            {title}
          </Typography>
        }
      />
    );

    if (showOptions) {
      return (
        <Accordion
          key={key}
          classes={{ root: styles.accordion }}
          expanded={selected && !stopped}
          square
          elevation={0}
          disabled={stopped}
        >
          <AccordionSummary classes={{ root: styles.summary, content: styles.content }}>
            {summary}
          </AccordionSummary>

          <AccordionDetails classes={{ root: styles.details }}>
            <div className={styles.header}>
              {needScores ? (
                <Typography
                  variant="caption"
                  style={{ opacity: hasResult(question) ? 1 : 0.6 }}
                >
                  scores
                </Typography>
              ) : null}
            </div>

            {options.map(option => renderOption(option, question))}
          </AccordionDetails>

          <BiMailSend
            className={styles.envelope}
            style={{
              color: theme.palette.primary.main,
              visibility: selected && hasResult(question) ? 'visible' : 'hidden',
            }}
          />
        </Accordion>
      );
    }

    return (
      <div key={key} className={styles.wrapper}>
        {summary}
      </div>
    );
  };

  return <div className={styles.questions}>{questions.map(renderQuestion)}</div>;
};

export default StopDialogContent;
